module.exports = __webpack_public_path__ + "static/media/servicios_estrategiaseguridad_justicia.8ee69e79.jpg";